<template>
  <form @submit="submitForm">
    <div class="row">
      <div
          class="d-flex justify-content-start align-items-center flex-column flex-md-row mx-auto mx-md-0 mb-4"
      >
        <div class="mb-3 mr-0 mb-md-0 mr-md-4">
          <image-uploader
              :imageSrc="companyDetails.logo_src"
              @imageUploaded="imageUploaded"
          ></image-uploader>
        </div>

        <div class="text-center text-md-left">
          <div class="wfh-company-details-name">
            {{ companyDetails.name }}
          </div>
          <div class="wfh-action-paragraph" style="color: #8392a6;">
            <span style="font-weight: 100;">Member Since</span>
            {{ currentDateFormatted }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="employeeCount" class="wfh-form-label">
            How many employees your company have?
          </label>
          <input
              required
              autofocus
              min="0"
              class="form-control wfh-input-box"
              type="number"
              id="employeeCount"
              v-model="formData.employee_count"
          />
        </div>
      </div>

      <div class="col-12 col-md-6">
        <label for="companyCountry" class="wfh-form-label">
          Country
        </label>
        <v-select
            id="companyCountry"
            :options="countries"
            :filterable="true"
            :clearable="false"
            v-model="formData.country"
        >
        </v-select>
      </div>

      <div class="col-12 col-md-6">
        <label for="companyCity" class="wfh-form-label">
          City
        </label>
        <v-select
            id="companyCity"
            :options="cities"
            :filterable="true"
            :clearable="false"
            v-model="formData.city"
        >
        </v-select>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="d-flex flex-column my-4" v-for="questions of dropDownOptions.companyReadiness">
          <label :for="questions.id" class="wfh-form-label">
            {{ questions.labelText }}
          </label>
          <div class="btn-group btn-group-toggle mt-2 overflow-auto flex-wrap flex-md-nowrap" :id="questions.id">
            <label
                class="btn radio-btn d-flex justify-content-center align-items-center mb-2 mb-md-0"
                v-bind:class="{active: value == formData[questions.formKey]}"
                style="max-width: 50%;"
                v-for="(option, value) in dropDownOptions[questions.dropdownKey]"
            >
              <i
                  class="fas fa-check-circle mr-1 mr-md-3"
                  style="font-size: 18px;"
                  v-if="value == formData[questions.formKey]"
              ></i>
              <input
                  type="radio"
                  :id="value"
                  v-model="formData[questions.formKey]"
                  :value="value"
              />
              {{ option }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="otherMeasures" class="wfh-form-label">
            What other measures do you take?
          </label>
          <textarea
              class="form-control wfh-input-box"
              id="otherMeasures"
              placeholder="Free masks, body heat detectors, etc."
              rows="4"
              v-model="formData.other_remarks"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="form-group my-4 d-flex justify-content-end">
      <button type="submit" class="btn wfh-btn-primary">
        Next Step
      </button>
    </div>
  </form>
</template>

<script>
import DropDownOptions from '../DropdownOptionsConfig';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
  components: { vSelect },

  props: {
    oldData: {
      required: false,
    },
  },

  data () {
    return {
      oldDataParsed: {},
      companyDetails: {
        id: '',
        name: '',
        logo_src: '',
      },
      formData: {
        company_id: null,
        employee_count: 10,
        country: '',
        city: '',
        logo: '',
        allow_work_from_home: 1,
        allow_travel: 1,
        allow_visitors: 1,
        allow_events: 1,
        other_remarks: '',
      },
      cities: [],
      countries: [],
      dropDownOptions: DropDownOptions,
    };
  },

  watch: {
    'formData.country' () {
      this.getCities();
    },
  },

  computed: {
    currentDateFormatted () {
      return moment().format('DD MMMM YYYY');
    },
  },

  methods: {
    async getCountries () {
      this.countries = await axios.get('/countries').then(data => data.data.data);
      this.formData.country = 'Malaysia';
    },

    async getCities () {
      this.cities = await axios.get('/cities/' + this.formData.country).then(data => data.data.data);

      if (this.formData.country.toLowerCase() == 'malaysia')
        return (this.formData.city = 'Kuala Lumpur');

      this.formData.city = this.cities[0];
    },

    imageUploaded (file, tempSrc) {
      this.formData.logo = file;
      this.companyDetails.logo_src = tempSrc;
    },

    async submitForm (e) {
      e.preventDefault();

      const formData = new FormData();

      Object.keys(this.formData).forEach(key => {
        if (this.formData[key] !== '') {
          formData.append(key, this.formData[key]);
        }
      });

      await axios.post(window.location.pathname, formData);

      window.location = '/dashboard';
    },
  },

  mounted () {
    this.getCountries();
    this.oldDataParsed = JSON.parse(this.oldData);
    this.companyDetails = this.oldDataParsed.companies[0];
    this.formData.company_id = this.companyDetails.id;

    Object.keys(this.formData).forEach(key => {
      if (this.companyDetails[key] !== '' && this.companyDetails[key]) {
        this.formData[key] = this.companyDetails[key];
      }
    });
  },
};
</script>

<style scoped lang="scss">
.logo-placeholder {
  border: 1px solid #d5d5d5;
  border-radius: 50%;
  height: 136px;
  width: 136px;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  text-align: center;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.overlay-logo {
  background-color: #d5d5d5;
  opacity: 0;
  width: 100%;
  height: 100%;

  &:hover {
    opacity: 0.2;
  }
}
</style>
